import api from '@/lib/axios';

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body: any = r.data;
  return (body?.data ?? body) as T;
}

export type ProgramItemType = 'single' | 'group' | 'team';

export interface ProgramItemCatalog {
  id: string;
  name: string;
  code: string | null;
  type: ProgramItemType;
  gradeCategory: string | null;
  maxMarks: number | null;
  quranProgram: boolean;
}

export interface ProgramCandidateItem {
  id: string;
  programItemId: string;
  programItemName: string;
  programItemType: ProgramItemType;
  groupLeaderId: string | null;
  isGroupLeader: boolean;
  judgeMark: number | null;
  grade: string | null;
  rank: number | null;
}

export interface ProgramCandidate {
  id: string;
  studentId: string;
  studentName: string;
  admissionNo: string;
  gender: 'male' | 'female' | 'other' | null;
  className: string;
  sectionName: string;
  academicYearId: string;
  chestNumber: number | null;
  oldChestNumber: string | null;
  items: ProgramCandidateItem[];
  createdAt: string;
  updatedAt: string;
}

export interface RegisterProgramCandidateData {
  studentId: string;
  academicYearId: string;
  programItemIds: string[];
}

export const ProgramCandidatesApi = {
  catalog: async (): Promise<ProgramItemCatalog[]> => unwrap(await api.get('/school/program-items')),

  list: async (params?: { academicYearId?: string }): Promise<ProgramCandidate[]> =>
    unwrap(await api.get('/school/program-candidates', { params })),

  register: async (data: RegisterProgramCandidateData): Promise<ProgramCandidate> =>
    unwrap(await api.post('/school/program-candidates', data)),

  remove: async (id: string): Promise<{ deleted: true; id: string }> =>
    unwrap(await api.delete(`/school/program-candidates/${id}`)),
};
